import HttpCliente from '../HttpCliente';

export const usuario = {
    Id: undefined,
    FirstName: '',
    LastName: '',
    DateOfBirth: '',
    Country: '',
    IsExternal: false,
    Email: '',
    Password: '',
    PhoneNumber: '',
  };

export const loginModel = {
    Email: '',  // Cambio aquí
    Password: '',  // Cambio aquí
};

/**
 * POST method - Inicia sesión con un usuario
 * @param {loginUsuario} usuario a iniciar sesión
 * @return {Promise} Promesa de obtención
 */

export const loginUser = (loginUsuario, setLoginError, setToken) => {
    return new Promise((resolve, reject) => {
        console.log(loginUsuario)
        HttpCliente.post("/Auth/Login", loginUsuario, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                const token = response.data.token; // El token devuelto por el servidor
                setToken(token); // Almacenar el token en el estado
                resolve(token); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setLoginError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        /*
        .then(response => {
            const token = response.data; // El token devuelto por el servidor
            setToken(token); // Almacenar el token en el estado
            resolve(token); // Resuelve la promesa con el token
        })
*/
        .catch(error => {
            if (error.response && error.response.data) {
                setLoginError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setLoginError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
        
        
    });
};

/**
 * POST method - Inicia sesión con un usuario
 * @param {loginUsuario} usuario a iniciar sesión
 * @return {Promise} Promesa de obtención
 */

export const loginAdminUser = (loginUsuario, setLoginError, setToken) => {
    return new Promise((resolve, reject) => {
        console.log(loginUsuario)
        HttpCliente.post("/Auth/Login-admin", loginUsuario, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                const token = response.data.token; // El token devuelto por el servidor
                setToken(token); // Almacenar el token en el estado
                resolve(token); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setLoginError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        /*
        .then(response => {
            const token = response.data; // El token devuelto por el servidor
            setToken(token); // Almacenar el token en el estado
            resolve(token); // Resuelve la promesa con el token
        })
*/
        .catch(error => {
            if (error.response && error.response.data) {
                setLoginError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setLoginError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
        
        
    });
};

/**
 * POST method - Registra un nuevo usuario
 * @param {usuario} usuario a registrar
 * @param {Function} setRegisterError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const registerUser = (usuario, setRegisterError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Usuario", usuario, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 201) {
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setRegisterError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setRegisterError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setRegisterError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * POST method - Inicia sesión con Google para administradores
 * @param {string} idToken token de Google
 * @param {Function} setLoginError función para establecer el estado de error
 * @param {Function} setToken función para establecer el token
 * @return {Promise} Promesa de obtención
 */
export const loginWithGoogleAdmin = (idToken, setLoginError, setToken) => {
    return new Promise((resolve, reject) => {
      HttpCliente.post("/Auth/google-admin", { idToken }, {
        headers: {
          'Content-Type': 'application/json',
          'accept': '*/*'
        }
      })
      .then(response => {
        if (response.data.status === 200) {
          const token = response.data.token;
          setToken(token);
          resolve(token);
        } else {
          setLoginError(response.data.message || 'Error en inicio de sesión con Google para administradores');
          reject(response.data.message);
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          setLoginError(error.response.data.message);
          reject(error.response.data.message);
        } else {
          setLoginError("Error de conexión");
          reject("Error de conexión");
        }
      });
    });
};